import type { LatestLoan } from '@/hooks/providers/useLatestLoanProvider';
import axiosInstance from '@/utils/axiosInstance';

export async function getClientLoansLatest() {
  return (await axiosInstance.get<LatestLoan>('/client/loans/latest')).data;
}
